// Iframe-side helper. Loaded once from each SPA's main.ts during bootstrap.
//
// Responsibilities:
//   * Initialise iframe-resizer/contentWindow so the parent can size us.
//   * Send a "cosModuleIsReady" postMessage to the parent.
//
// The "iframe-resizer/js/iframeResizer.contentWindow.js" side-effect import
// installs a global listener that talks to the parent's iFrameResize() init.

import "iframe-resizer/js/iframeResizer.contentWindow.js";

const COS_MSG_ENVELOPE = { isCosMsg: true } as const;

/**
 * True, wenn die SPA direkt im Browser läuft (eigener Tab) statt als
 * Iframe in der Kunden-CMS-Seite. Der Vergleich fasst das Parent-Window
 * nur per Identität an (kein Property-Zugriff), funktioniert also auch
 * bei Cross-Origin-Einbettung. Steuert die Standalone-Chrome der App
 * (eigener Header/Footer) — im Iframe liefert die umgebende
 * Kundenseite beides.
 */
export function isStandalone(): boolean {
  return window.parent === window;
}

export function notifyReady(): void {
  if (isStandalone()) return;
  window.parent.postMessage(
    { ...COS_MSG_ENVELOPE, method: "cosModuleIsReady" },
    "*"
  );
}
